import { PageFlowContext } from './index'

const FlowStep = ({ name, children }) => (
  <PageFlowContext.Consumer>
    {(currentStep) => (currentStep === name ? children : null)}
  </PageFlowContext.Consumer>
)

export default FlowStep
